const rolesEnum = {
    admin:                 'admin',
    juniorAdmin:           'junior-admin',
    adminPanel:            'adminPanel',
    children:              'children',
    parent:                'parent',
    hrManager:             'hr-manager',
    htPanel:               'htPanel',
    managerPanel:          'managerPanel',
    personalManager:       'personal-manager',
    seminarian:            'seminarian',
    seniorSeminarian:      'senior-seminarian',
    seminarianPanel:       'sPanel',
    seniorSeminarianPanel: 'ssPanel',
    updateOwnProfile:      'updateOwnProfile',
}

export default rolesEnum